import axiosApiInstanceMain from "../../../../api/axiosApiClient";
import { InternalAPIError } from "../../../../utils/apiErrors";
import { handleApiError } from "../../../../utils/globalErrorHandler";
const MKS_HISTORY_APP_API_URL = process.env.REACT_APP_CHAT_HISTORY_WRAPPER_URL;
const REACT_APP_MKS_API_URL = process.env.REACT_APP_MKS_API_URL;

export const getHistoryByDateRange = async (data) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${MKS_HISTORY_APP_API_URL}/history/skill_daily_user_count`,
      {
        range: data,
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (ex) {
    console.log(ex);
  }
};

export const getResourceCost = async (skillId, range) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${REACT_APP_MKS_API_URL}skillstore/GetSkillResourceCostByDays`,
      {
        SkillId: skillId,
        DaysBack: range,
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (ex) {
    console.log(ex);
  }
};

export const getMostSkillUsedandTop10Skills = async (skillId, range) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${MKS_HISTORY_APP_API_URL}/history/skill_analysis`,
      {
        skillId: skillId,
        range: range,
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (ex) {
    console.log(ex);
  }
};
